'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _vacations = require('../actions/vacations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(sagaGetVacation),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sagaAddVacation),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(sagaDeleteVacation),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(sagaCountReservationInRange),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(vacationSaga);

function sagaGetVacation(payload) {
  var startDate, endDate, bodyRequest, apiObj, res, vacations;
  return _regenerator2.default.wrap(function sagaGetVacation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          startDate = payload.startDate, endDate = payload.endDate;
          bodyRequest = {
            AccountRooms: payload.selectedDoctors.map(function (doctor) {
              return {
                AccountKey: doctor.AccountKey,
                RoomKey: doctor.RoomKey
              };
            })
          };


          bodyRequest = Object.assign({}, bodyRequest, {
            From: startDate,
            To: endDate
          });

          apiObj = new _webSso.AuthApi();
          _context.next = 6;
          return apiObj.post(_webUtils.Urls.getVacations, bodyRequest);

        case 6:
          res = _context.sent;

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context.next = 14;
            break;
          }

          vacations = [];

          if (res.data) {
            vacations = res.data.map(function (doctor) {
              var DoctorName = payload.doctorsNames.get(doctor.AccountKey);
              var RoomName = payload.roomsNames.get(doctor.RoomKey);
              var Model = [];
              var modelFrom = new Date(doctor.From);
              var modelTo = new Date(doctor.To);

              Model.push({
                From: modelFrom.getMonth() + 1 + '/' + modelFrom.getDate() + '/' + modelFrom.getFullYear() + ' ' + doctor.From.split('T')[1],
                To: modelTo.getMonth() + 1 + '/' + modelTo.getDate() + '/' + modelTo.getFullYear() + ' ' + doctor.To.split('T')[1]
              });

              return {
                Model: Model,
                AccountKey: doctor.AccountKey,
                RoomKey: doctor.RoomKey,
                DoctorName: DoctorName,
                RoomName: RoomName
              };
            });
          }
          _context.next = 12;
          return (0, _effects.put)({ type: _vacations.VACATIONS.LOAD_DONE, vacations: vacations });

        case 12:
          _context.next = 16;
          break;

        case 14:
          _context.next = 16;
          return (0, _effects.put)({ type: _vacations.VACATIONS.LOAD_FAIL });

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getBodySetVacation() {
  var vacations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var IsDeleted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var apiVacationModel = {
    ActionMaker: 'Doctor',
    AccountRoomActions: []
  };

  var vacationDetails = vacations;
  vacationDetails.doctors.forEach(function (doctor) {
    var accountRoomActionsObj = {
      AccountKey: doctor.AccountKey,
      RoomKey: doctor.RoomKey,
      Model: []
    };

    accountRoomActionsObj.Model.push({
      From: vacationDetails.startDate,
      To: vacationDetails.endDate,
      IsDeleted: IsDeleted
    });

    apiVacationModel.AccountRoomActions.push(accountRoomActionsObj);
  });
  return apiVacationModel;
}

function sagaAddVacation(payload) {
  var bodyReq, apiObj, res;
  return _regenerator2.default.wrap(function sagaAddVacation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          bodyReq = getBodySetVacation(payload.vacation, 0);
          apiObj = new _webSso.AuthApi();
          _context2.next = 4;
          return apiObj.post(_webUtils.Urls.setVacations, bodyReq);

        case 4:
          res = _context2.sent;


          if (payload.callback) {
            payload.callback(payload.callbackParams);
          }

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)({
            type: _vacations.VACATIONS.ADD_DONE,
            vacation: bodyReq.AccountRoomActions,
            rooms: payload.rooms,
            doctors: payload.doctors
          });

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)({ type: _vacations.VACATIONS.ADD_FAIL, res: res });

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function sagaDeleteVacation(payload) {
  var bodyReq, apiObj, res;
  return _regenerator2.default.wrap(function sagaDeleteVacation$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          bodyReq = getBodySetVacation(payload.deleteVacation, 1);
          apiObj = new _webSso.AuthApi();
          _context3.next = 4;
          return apiObj.post(_webUtils.Urls.setVacations, bodyReq);

        case 4:
          res = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context3.next = 10;
            break;
          }

          _context3.next = 8;
          return (0, _effects.put)({
            type: _vacations.VACATIONS.DELETE_DONE,
            vacation: payload.deleteVacation
          });

        case 8:
          _context3.next = 12;
          break;

        case 10:
          _context3.next = 12;
          return (0, _effects.put)({ type: _vacations.VACATIONS.DELETE_FAIL, res: res });

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function sagaCountReservationInRange(payload) {
  var vacationDetails, vacationDetailsBody, apiObj, countReservationsInRangeApi, reservationsInRange;
  return _regenerator2.default.wrap(function sagaCountReservationInRange$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          vacationDetails = payload.data;
          vacationDetailsBody = [];

          vacationDetails.doctors.forEach(function (doctor) {
            vacationDetailsBody.push({
              AccountKey: doctor.AccountKey,
              RoomKey: doctor.RoomKey,
              From: vacationDetails.startDate,
              To: vacationDetails.endDate
            });
          });

          apiObj = new _webSso.AuthApi();
          _context4.next = 6;
          return apiObj.post(_webUtils.Urls.countReservationsInRange, vacationDetailsBody);

        case 6:
          countReservationsInRangeApi = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(countReservationsInRangeApi.status)) {
            _context4.next = 14;
            break;
          }

          reservationsInRange = 0;

          countReservationsInRangeApi.data.forEach(function (doctor) {
            reservationsInRange += doctor.ReservationsCount;
          });

          _context4.next = 12;
          return (0, _effects.put)({
            type: _vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD_DONE,
            reservationsInRange: reservationsInRange
          });

        case 12:
          _context4.next = 16;
          break;

        case 14:
          _context4.next = 16;
          return (0, _effects.put)({
            type: _vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD_FAIL,
            countReservationsInRangeApi: countReservationsInRangeApi
          });

        case 16:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function vacationSaga() {
  return _regenerator2.default.wrap(function vacationSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_vacations.VACATIONS.LOAD, sagaGetVacation);

        case 2:
          _context5.next = 4;
          return (0, _effects.takeEvery)(_vacations.VACATIONS.ADD, sagaAddVacation);

        case 4:
          _context5.next = 6;
          return (0, _effects.takeEvery)(_vacations.VACATIONS.DELETE, sagaDeleteVacation);

        case 6:
          _context5.next = 8;
          return (0, _effects.takeEvery)(_vacations.VACATIONS.RESERVATIONS_IN_RANGE.LOAD, sagaCountReservationInRange);

        case 8:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

exports.default = vacationSaga;
module.exports = exports['default'];